import React, { useEffect, useState } from "react";
import Toggle from "@atlaskit/toggle";
import Textfield from "@atlaskit/textfield";
import { Label } from "@atlaskit/form";
import { ResponseFileTarget } from "../../../../../../common/interfaces/flow/action/WebRequestAction";

const ResponseFileConfiguration = ({ action, updateCallback }) => {
  const [enabled, setEnabled] = useState(false);
  const [fileNameTemplate, setFileNameTemplate] = useState("");
  const [contentTypeTemplate, setContentTypeTemplate] = useState("");

  useEffect(() => {
    setEnabled(action?.responseFileConfig?.enabled ?? false);
    setFileNameTemplate(action?.responseFileConfig?.fileNameTemplate ?? "");
    setContentTypeTemplate(action?.responseFileConfig?.contentTypeTemplate ?? "");
  }, [action]);

  const ensureConfig = () => {
    if (!action.responseFileConfig) {
      action.responseFileConfig = {
        enabled: false,
        target: ResponseFileTarget.INPUT_FILES,
      };
    } else if (!action.responseFileConfig.target) {
      action.responseFileConfig.target = ResponseFileTarget.INPUT_FILES;
    }
    return action.responseFileConfig;
  };

  const markDirty = () => {
    updateCallback();
  };

  const onToggle = () => {
    const config = ensureConfig();
    const nextEnabled = !enabled;
    config.enabled = nextEnabled;
    setEnabled(nextEnabled);
    markDirty();
  };

  const onChangeFileName = (e) => {
    const config = ensureConfig();
    config.fileNameTemplate = e.target.value;
    setFileNameTemplate(e.target.value);
    markDirty();
  };

  const onChangeContentType = (e) => {
    const config = ensureConfig();
    config.contentTypeTemplate = e.target.value;
    setContentTypeTemplate(e.target.value);
    markDirty();
  };

  return (
    <div className="ihub-response-file-configuration">
      <div className="ihub-response-file-toggle">
        <Toggle id="response-file-toggle" size="regular" isChecked={enabled} onChange={onToggle} />
        <span style={{ position: "relative", top: "-4px" }}>Store response as file</span>
      </div>
      {enabled && (
        <>
          <p className="ihub-action-tab-description">
            Store the HTTP response as an attachment so later actions can use it via <code>&#123;&#123;input.files&#125;&#125;</code>.
          </p>
          <div className="ihub-response-file-inputs">
            <Label>File name (optional)</Label>
            <Textfield isCompact placeholder="e.g. {{issue.key}}-export.csv" value={fileNameTemplate} onChange={onChangeFileName} />
            <Label>Content type (optional)</Label>
            <Textfield isCompact placeholder="e.g. text/csv" value={contentTypeTemplate} onChange={onChangeContentType} />
          </div>
          <p className="ihub-action-tab-description">
            When enabled, the flow adds the file to <code>input.files</code> for this action’s scope and child actions. Use
            multipart/form-data in later requests to pass the file forward.
          </p>
        </>
      )}
    </div>
  );
};

export default ResponseFileConfiguration;
